import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface UserState {
  user: null | any;
  setUser: (user: any) => void;
  roles: null | string[];
  setRoles: (roles: string[]) => void;
  notifications: null | any[];
  setNotifications: (notifications: any[]) => void;
  accessToken: null | string;
  setAccessToken: (accessToken: string | null) => void;
  accessTokenExpires: null | string;
  setAccessTokenExpires: (accessTokenExpires: string | null) => void;
  refreshToken: null | string;
  setRefreshToken: (refreshToken: string | null) => void;
  refreshTokenExpires: null | string;
  setRefreshTokenExpires: (refreshTokenExpires: string | null) => void;
  impersonationToken: null | string;
  setImpersonationToken: (impersonationToken: string | null) => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      roles: null,
      accessToken: null,
      accessTokenExpires: null,
      refreshToken: null,
      refreshTokenExpires: null,
      notifications: null,
      impersonationToken: null,
      setUser: (user) => set({ user }),
      setRoles: (roles) => set({ roles }),
      setAccessToken: (accessToken) => set({ accessToken }),
      setAccessTokenExpires: (accessTokenExpires) =>
        set({ accessTokenExpires }),
      setRefreshToken: (refreshToken) => set({ refreshToken }),
      setRefreshTokenExpires: (refreshTokenExpires) =>
        set({ refreshTokenExpires }),
      setNotifications: (notifications) => set({ notifications }),
      setImpersonationToken: (impersonationToken) =>
        set({ impersonationToken }),
    }),
    {
      name: "user-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        roles: state.roles,
        accessToken: state.accessToken,
        accessTokenExpires: state.accessTokenExpires,
        refreshToken: state.refreshToken,
        refreshTokenExpires: state.refreshTokenExpires,
        impersonationToken: state.impersonationToken,
      }),
    }
  )
);
